// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","InstagramEmbed":"bau_a","InstagramEmbed__mask":"bau_b bhn_bi bhn_bo bhn_wz"};